// CustomInput.tsx
import React, { forwardRef } from "react";
import { Button, Box } from "@mui/material";
import dayjs from "dayjs";
import {ReactComponent as IconCalendarFilled} from '../../assets/images/icons/calendarFilled.svg';
import { customInputStyle } from "./style";

interface CustomInputProps {
  onClick: () => void;
  startDate?: Date;
  endDate?: Date;
  isMobile?: boolean;
}

const CustomInput = forwardRef<HTMLButtonElement, CustomInputProps>(
  ({ onClick, startDate, endDate, isMobile }, ref) => (
    <Box sx={customInputStyle.mainWrapper}>
      <Button
        fullWidth={isMobile ? true : false}
        onClick={onClick}
        ref={ref}
        variant="outlined"
        endIcon={
        <IconCalendarFilled style={customInputStyle.calendarIcon}/>
        }
        sx={customInputStyle.button}
      >
        {startDate ? dayjs(startDate).format("DD/MM/YYYY") : "Start Date"} - {" "}
        {endDate ? dayjs(endDate).format("DD/MM/YYYY") : "End Date"}
      </Button>
    </Box>
  )
);

CustomInput.displayName = "CustomInput";

export default CustomInput;
